import './styles/globals.css';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { RelayEnvironmentProvider } from 'react-relay';
import { AppRoutes } from '@/routes';
import { createEnvironment } from '@/relay/environment';
import { ThemeProvider } from '@/contexts/ThemeContext';
import { ToastProvider } from "@lecartte/shared-ui/components/Toast";
import { initMetaPixel } from '@/services/metaPixel';

const environment = createEnvironment();
const container = document.getElementById('root');
if (!container) throw new Error('No #root element found');

// Boot the Meta Pixel (no-op unless LECARTTE_META_PIXEL_ID is set).
initMetaPixel();

createRoot(container).render(
  <RelayEnvironmentProvider environment={environment}>
    <ThemeProvider>
      <ToastProvider>
        <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
          <AppRoutes />
        </BrowserRouter>
      </ToastProvider>
    </ThemeProvider>
  </RelayEnvironmentProvider>
);
